import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Icon from '../../../atoms/icon';
import styles from './morningstar-rating-filter.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import { mStarFilterUpdate } from '../../../../stores/screener/screener-redux-store';
import ButtonViewGlossary from '../../../atoms/button-view-glossary';

const className = augmentClassName(styles);

export const MorningStarRating = ({ filterArray, currentVal, updateMStarVal, addMargin }) => {
  const heading = 'Rating';

  return (
    <Col {...className(`'root', 'mx-6', ${addMargin ? 'mx-6' : ''}`)}>
      <Row {...className('head-row', 'align-items-center')}>
        <h3 {...className('heading')}> {heading} </h3>
        <ButtonViewGlossary glossarySection="Overall Morningstar Rating" isScreener solid />
      </Row>
      <RatingRow
        filterArray={filterArray}
        currentVal={currentVal}
        updateMStarVal={updateMStarVal}
      />
    </Col>
  );
};

MorningStarRating.propTypes = {
  updateMStarVal: PropTypes.func,
  currentVal: PropTypes.number,
  filterArray: PropTypes.array,
  addMargin: PropTypes.bool
};

MorningStarRating.defaultProps = {
  addMargin: true
};

const RatingRow = ({ filterArray, currentVal, updateMStarVal }) => {
  const [gteRating, setgteRating] = useState(0);
  const [showText, setShowText] = useState(false);

  const srText = [
    'first star, filters ratings of one star or greater',
    'second star, filters ratings of two stars or greater',
    'third star, filters ratings of three stars or greater',
    'fourth star, filters ratings of four stars or greater',
    'fifth star, filters ratings of five stars'
  ];

  useEffect(() => {
    setgteRating(currentVal + 1);
    if (currentVal === -1) {
      setShowText(false);
    } else {
      setShowText(true);
    }
  }, [currentVal]);

  const handleClick = newValue => {
    updateMStarVal(newValue);
  };

  const keyHandler = (e, idx) => {
    if (e.key === ' ' || e.key === 'spacebar') {
      e.stopPropagation();
      return handleClick(idx);
    }
    return true;
  };

  return (
    <Row {...className('stars-container')}>
      <span
        {...className('stars')}
        // TIAA Analytics Tracking
        data-analytics-linkname="Rating"
        data-analytics-section="component"
        data-analytics-componenttype="CustomFilters"
        // END TIAA Analytics Tracking
      >
        {filterArray.map((el, index) => (
          <span
            {...className('d-inline')}
            data-key={`${el || ''}-${index}`}
            key={`${el || ''}-${index}`}
          >
            <Icon.Star
              role="checkbox"
              tabIndex="0"
              aria-label={srText[index]}
              aria-checked={el}
              {...className('icon-star', el ? 'selected' : 'unselected')}
              onClick={() => handleClick(index)}
              onKeyPress={() => keyHandler(event, index)}
            />
          </span>
        ))}
      </span>
      <div {...className('rating-text-row', !showText && 'invisible')}>
        Includes funds rated {gteRating} stars {gteRating < 5 && 'and higher'}
      </div>
    </Row>
  );
};

RatingRow.propTypes = {
  initRating: PropTypes.arrayOf(PropTypes.object),
  updateMStarVal: PropTypes.func,
  filterArray: PropTypes.array,
  currentVal: PropTypes.number
};

const mapStateToProps = state => {
  return {
    filterArray: state.filterReducer.filters.MStarFilterArray,
    currentVal: state.filterReducer.filters.MStarValue
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateMStarVal: val => dispatch(mStarFilterUpdate(val))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MorningStarRating);
